import { defineComponent } from 'navigation-components/platform/models';
import { capabilities } from '../../capabilities';
import { args } from '../../common/args';
import { getPortalId } from '../../common/utils';
import { DEMO_EXIT_CONFIRMATION_COMPONENT, Tags } from '../constants';
import { getStyle } from './internal';
export const demoExitConfirmationComponentDef = defineComponent(DEMO_EXIT_CONFIRMATION_COMPONENT, {
  name: DEMO_EXIT_CONFIRMATION_COMPONENT,
  path: `/demo-exit-confirmation/${getPortalId()}`,
  capabilities: [capabilities.SHOW_DEMO_EXIT_CONFIRMATION_CAP.getName(), capabilities.HIDE_COMPONENT_CAP.getName(), capabilities.NAVIGATE_TO_CAP.getName()],
  iframeProps: {
    style: getStyle(),
    id: 'demo-exit-confirmation',
    ['data-test-id']: 'demo-exit-confirmation-iframe',
    title: 'demo-exit-confirmation-iframe'
  },
  propsSchema: {
    url: args.string(),
    appSource: args.string()
  },
  initialProps: {
    url: '',
    appSource: ''
  },
  deferLoading: true,
  initiallyOpen: true,
  tags: [Tags.MODAL]
});